import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-23c766ce")

_pushScopeId("data-v-23c766ce")
const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "nav__title" }
const _hoisted_3 = { class: "body" }
const _hoisted_4 = { class: "form" }
const _hoisted_5 = { class: "actions" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_NavBar = _resolveComponent("NavBar")
  const _component_OInputText = _resolveComponent("OInputText")
  const _component_FormField = _resolveComponent("FormField")
  const _component_OInputNumber = _resolveComponent("OInputNumber")
  const _component_OTextarea = _resolveComponent("OTextarea")
  const _component_KoiStatus = _resolveComponent("KoiStatus")
  const _component_UserLog = _resolveComponent("UserLog")
  const _component_OButton = _resolveComponent("OButton")
  const _component_BlockUI = _resolveComponent("BlockUI")
  const _directive_focus = _resolveDirective("focus")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_BlockUI, { blocked: _ctx.busy }, {
      default: _withId(() => [
        _createVNode(_component_NavBar, { navigation: "back" }, {
          body: _withId(() => [
            _createVNode("div", _hoisted_2, _toDisplayString(_ctx.title), 1)
          ]),
          _: 1
        }),
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode(_component_FormField, {
              label: "Tamanho",
              invalid: _ctx.v$.form.size.$invalid && _ctx.submitted,
              loading: _ctx.loading,
              "invalid-message": "Tamanho inválido.",
              "data-test": "fieldSize"
            }, {
              default: _withId(() => [
                _withDirectives(_createVNode(_component_OInputText, {
                  modelValue: _ctx.form.size,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.size = $event)),
                  placeholder: "Tamanho",
                  "data-test": "size",
                  class: { 'p-invalid': _ctx.v$.form.size.$invalid && _ctx.submitted }
                }, null, 8, ["modelValue", "class"]), [
                  [_directive_focus]
                ])
              ]),
              _: 1
            }, 8, ["invalid", "loading"]),
            _createVNode(_component_FormField, {
              label: "Preço",
              invalid: _ctx.v$.form.price.$invalid && _ctx.submitted,
              loading: _ctx.loading,
              "invalid-message": "Preço inválido.",
              "data-test": "fieldPrice"
            }, {
              default: _withId(() => [
                _createVNode(_component_OInputNumber, {
                  modelValue: _ctx.price,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.price = $event)),
                  "min-fraction-digits": 2,
                  "max-fraction-digits": 2,
                  min: 0,
                  locale: "pt-BR",
                  placeholder: "Preço",
                  "data-test": "price",
                  class: _ctx.v$.form.price.$invalid && _ctx.submitted ? 'p-invalid' : ''
                }, null, 8, ["modelValue", "class"])
              ]),
              _: 1
            }, 8, ["invalid", "loading"]),
            _createVNode(_component_FormField, {
              label: "URL Vídeo",
              invalid: _ctx.v$.form.videoUrl.$invalid && _ctx.submitted,
              loading: _ctx.loading,
              "invalid-message": "URL é inválida.",
              "data-test": "fieldVideoUrl"
            }, {
              default: _withId(() => [
                _createVNode(_component_OInputText, {
                  modelValue: _ctx.form.videoUrl,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.videoUrl = $event)),
                  placeholder: "URL",
                  "data-test": "videoUrl",
                  class: { 'p-invalid': _ctx.v$.form.videoUrl.$invalid && _ctx.submitted }
                }, null, 8, ["modelValue", "class"])
              ]),
              _: 1
            }, 8, ["invalid", "loading"]),
            _createVNode(_component_FormField, {
              label: "Observações",
              loading: _ctx.loading
            }, {
              default: _withId(() => [
                _createVNode(_component_OTextarea, {
                  modelValue: _ctx.form.notes,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.notes = $event)),
                  "auto-resize": "",
                  placeholder: "Observações",
                  "data-test": "notes"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["loading"]),
            _createVNode(_component_FormField, {
              label: "Status",
              loading: _ctx.loading,
              "data-test": "fieldStatus",
              "invalid-message": "Status inválido."
            }, {
              default: _withId(() => [
                _createVNode(_component_KoiStatus, {
                  modelValue: _ctx.form.status,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.form.status = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["loading"])
          ]),
          _createVNode(_component_UserLog, {
            class: "user-log",
            data: _ctx.userLog
          }, null, 8, ["data"]),
          _createVNode("div", _hoisted_5, [
            _createVNode(_component_OButton, {
              class: "p-button-primary",
              label: "SALVAR",
              loading: _ctx.saving,
              "data-test": "save",
              onClick: _ctx.handleSave
            }, null, 8, ["loading", "onClick"]),
            (_ctx.editing)
              ? (_openBlock(), _createBlock(_component_OButton, {
                  key: 0,
                  class: "p-button-danger p-button-outlined",
                  label: "DELETAR",
                  loading: _ctx.deleting,
                  "data-test": "delete",
                  onClick: _ctx.handleDelete
                }, null, 8, ["loading", "onClick"]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }, 8, ["blocked"])
  ]))
})